import {useState} from 'react';
import {shallowEqual, useSelector, useStore} from 'react-redux';
import {TimeSince} from '~/ViewInvitation/common/TimeSince';
import {deletePost} from '~/ViewInvitation/reducers/apiActions';
import {selectPost} from '~/ViewInvitation/reducers/posts';
import {LikeButton} from '~/ViewInvitation/routes/Guests/LikeButton';
import {Typography} from '~library/atoms/Typography';
import {ActionSheetModal} from '../../common/Modal/ActionSheetModal';

export const Reply = (props) => {
  const {handleSetEditing, postId, isEditingThisComment} = props;
  const isParentPost = false;
  const store = useStore();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteConfirmed, setDeleteConfirmed] = useState(false);

  const post = useSelector(selectPost(postId), shallowEqual);

  const userIdFromStore = useSelector((s) => s.user.userId);

  const hasRSVPd = useSelector((state) => state.rsvp?.hasRsvpd ?? false);

  if (!post) return null;

  const whenPosted = post.when.slice(0, -5);
  const comment = post.comment || '';
  const canUserEdit = comment && post.userId === userIdFromStore; // RSVP comments can't be edited here
  const showIconRow = hasRSVPd;
  const {guestName} = post;

  const handleEditClick = () => {
    handleSetEditing(postId);
  };

  const handleDelete = () => {
    store.dispatch(deletePost(postId));
  };

  return (
    <div className="wic__guest-post reply">
      <div className="wic__guest-post-details">
        <Typography variant="paragraph3" classNames="wic__guest-name">
          {guestName}
        </Typography>
      </div>
      {!isEditingThisComment && (
        <>
          <Typography variant="paragraph3" data-qa-id="reply-comment">
            {comment}
          </Typography>
          <div className="wic__guest-post-ctas">
            {whenPosted && (
              <>
                <TimeSince timestamp={whenPosted} />
                <span>|</span>
              </>
            )}
            {userIdFromStore && showIconRow && (
              <>
                <LikeButton
                  userId={userIdFromStore}
                  postId={postId}
                  post={post}
                  dataQaId="reply-like"
                />
                <span>|</span>
              </>
            )}
            {canUserEdit && !isParentPost && (
              <>
                <button
                  type="button"
                  onClick={() => handleEditClick()}
                  className="unstyled-button link small"
                  data-qa-id="comment-edit"
                >
                  Edit
                </button>
                <span>|</span>
                <button
                  type="button"
                  onClick={() => setShowDeleteModal(true)}
                  className="unstyled-button link small"
                  data-qa-id="comment-delete"
                >
                  Delete
                </button>
              </>
            )}
          </div>
        </>
      )}
      {/* Because deleting the post causes this component to stop rendering - we delay the
          call to delete the post until after the modal has finished animating off the screen
          TODO: Add a flag to the option items that causes the action to be called onAfterClose instead of onClick
          TODO: so we can avoid repeating this logic every time we have a delete option
      */}
      <ActionSheetModal
        onClose={() => {
          setShowDeleteModal(false);
        }}
        onAfterClose={() => {
          if (deleteConfirmed) handleDelete();
        }}
        isOpen={showDeleteModal}
        title="Delete Comment"
        message="Are you sure you want to delete this comment?"
        optionsList={[
          {
            label: 'Delete',
            action: () => setDeleteConfirmed(true),
            destructive: true,
          },
        ]}
      />
    </div>
  );
};
